interface EmptyStateProps {
  title: string;
  description: string;
  onReset?: () => void;
  resetLabel?: string;
}

export default function EmptyState({ title, description, onReset, resetLabel = '重置筛选' }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-background-100">
        <i className="ri-search-eye-line text-3xl text-foreground-400"></i>
      </div>
      <h3 className="mb-2 font-heading text-lg font-semibold text-foreground-950">{title}</h3>
      <p className="mb-6 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
        >
          <i className="ri-refresh-line"></i>
          {resetLabel}
        </button>
      )}
    </div>
  );
}